/**
 * @file 言語データ：英語 定数管理
 */

export const en = {
    name: "English",
    viewThisCase: "View this case in English",
};
